import React from 'react';
import { CTAButton } from '../ui/CTAButton';
import { PriceDisplay } from '../ui/PriceDisplay';
import { ProgressBar } from '../ui/ProgressBar';
export function ValueStackSection() {
  return <section className="py-10 md:py-16 px-4 bg-ink" data-id="element-205">
      <div className="max-w-[700px] mx-auto" data-id="element-206">
        <div className="text-center mb-8" data-id="element-207">
          <h2 className="text-[26px] md:text-[32px] text-cream mb-2" data-id="element-208">
            <PriceDisplay price={208} data-id="element-209" /> de valor. Por{' '}
            <PriceDisplay price={14.99} data-id="element-210" />.
          </h2>
          <p className="text-[18px] text-cream/80 italic" data-id="element-211">
            Todo lo que recibís hoy.
          </p>
        </div>

        <div className="bg-white border border-divider shadow-md overflow-hidden mb-8 w-full" data-id="element-212">
          <table className="w-full text-left border-collapse" data-id="element-213">
            <tbody data-id="element-214">
              <tr className="border-b border-divider bg-white" data-id="element-215">
                <td className="py-2.5 px-4 text-[15px] text-ink" data-id="element-216">
                  222 Recetas de Cosméticos Naturales
                </td>
                <td className="py-2.5 px-4 text-[15px] text-muted text-right whitespace-nowrap" data-id="element-217">
                  <PriceDisplay price={97} data-id="element-218" />
                </td>
              </tr>
              <tr className="border-b border-divider bg-sage" data-id="element-219">
                <td className="py-2.5 px-4 text-[15px] text-ink" data-id="element-220">
                  BONO 01 — Checklist de Seguridad
                </td>
                <td className="py-2.5 px-4 text-[15px] text-muted text-right whitespace-nowrap" data-id="element-221">
                  <PriceDisplay price={47} data-id="element-222" />
                </td>
              </tr>
              <tr className="border-b border-divider bg-white" data-id="element-223">
                <td className="py-2.5 px-4 text-[15px] text-ink" data-id="element-224">
                  BONO 02 — Guía de Conservantes
                </td>
                <td className="py-2.5 px-4 text-[15px] text-muted text-right whitespace-nowrap" data-id="element-225">
                  <PriceDisplay price={37} data-id="element-226" />
                </td>
              </tr>
              <tr className="border-b border-divider bg-sage" data-id="element-227">
                <td className="py-2.5 px-4 text-[15px] text-ink" data-id="element-228">
                  BONO 03 — Guía para Emprendedoras
                </td>
                <td className="py-2.5 px-4 text-[15px] text-muted text-right whitespace-nowrap" data-id="element-229">
                  <PriceDisplay price={27} data-id="element-230" />
                </td>
              </tr>
              <tr className="bg-accent text-white" data-id="element-231">
                <td className="py-3 px-4 text-[17px] font-bold" data-id="element-232">VALOR TOTAL</td>
                <td className="py-3 px-4 text-[17px] font-bold text-right whitespace-nowrap line-through" data-id="element-233">
                  <PriceDisplay price={208} data-id="element-234" />
                </td>
              </tr>
              <tr className="bg-pain text-white" data-id="element-235">
                <td className="py-4 px-4 text-[17px] font-bold" data-id="element-236">
                  TU PRECIO HOY
                </td>
                <td className="py-4 px-4 text-[20px] font-bold text-right whitespace-nowrap text-cream" data-id="element-237">
                  <PriceDisplay price={14.99} data-id="element-238" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="mb-6" data-id="element-239">
          <ProgressBar data-id="element-240" />
        </div>

        <div className="text-center" data-id="element-241">
          <CTAButton className="w-full md:max-w-md mx-auto" isCheckout={true} data-id="element-242">
            AGREGAR AL CARRITO →
          </CTAButton>
          <p className="text-[12px] text-cream/70 mt-3 font-bold" data-id="element-243">
            🔒 Compra protegida · PDF descargable al instante
          </p>
        </div>
      </div>
    </section>;
}